import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import register from "preact-custom-element";
import SwatchProductActions from "../../pdp-swatch-modal/swatch-product-actions";
import {
  SWATCH_TOTAL_CAP,
  countCartSwatches,
  swatchCapApplies,
} from "../../helpers/swatchCap";

function ProductFormSwatchActions({
  limitEach,
  variantId,
  swatchType,
  productGid,
  isQuickView,
}) {
  const [cartData, setCartData] = useState(window.cartData);
  const [error, setError] = useState(null);

  const cartItems = cartData?.items || [];

  const onError = () => {
    setError(window.localeStrings.product.add_to_cart_error);
    setTimeout(() => {
      setError(null);
    }, 3000);
  };

  const item = cartItems.find(
    (cartItem) => parseInt(cartItem.variant_id) === parseInt(variantId),
  );

  // Trade groups get a per-swatch allowance instead of the cart-wide cap. This
  // swatch's own line is already counted, so an in-cart swatch shows Remove
  // rather than a blocked Add.
  const atLimit =
    !item &&
    swatchCapApplies() &&
    countCartSwatches(cartData) >= SWATCH_TOTAL_CAP;

  useEffect(() => {
    const onCartUpdated = (e) => {
      setCartData(e.detail.cartData);
    };

    document.addEventListener("cart:updated", onCartUpdated);

    return () => document.removeEventListener("cart:updated", onCartUpdated);
  }, [setCartData]);

  return (
    <>
      {atLimit && (
        <p className="product-form-swatch-actions__limit">
          {window.localeStrings.swatch_details.limit_reached}
        </p>
      )}
      <SwatchProductActions
        variantId={variantId}
        productGid={productGid}
        isQuickView={isQuickView === "true"}
        item={item}
        limitEach={parseInt(limitEach)}
        addDisabled={atLimit}
        onError={onError}
        onAfterAdd={() => {
          document.dispatchEvent(new CustomEvent("markup-modal:close"));
          document.dispatchEvent(new CustomEvent("mini-cart:open"));
        }}
        classPrefix="product-form-swatch-actions"
        removeButtonClasses="button button--grey button--full"
        addButtonClasses="button button--black button--full"
        addToCartText={window.localeStrings.product.add_to_cart}
        removeFromCartText={window.localeStrings.product.remove_from_cart}
        swatchType={swatchType}
      />
      {error && (
        <div
          className="product-form-swatch-actions__error"
          dangerouslySetInnerHTML={{
            __html: error,
          }}
        ></div>
      )}
    </>
  );
}

if (!customElements.get("product-form-swatch-actions")) {
  register(
    ProductFormSwatchActions,
    "product-form-swatch-actions",
    ["limit-each", "variant-id", "swatch-type", "product-gid", "is-quick-view"],
    {
      shadow: false,
    },
  );
}
